import React, { useState } from "react";
import { Carousel, Button } from "react-bootstrap";
import { heroSlides } from "../data/siteContent";
import styles from "./HeroSection.module.css";

export const HeroSection = () => {
  const [imageLoaded, setImageLoaded] = useState({});

  const handleImageLoad = (id) => {
    setImageLoaded((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <Carousel>
      {heroSlides.map((slide) => (
        <Carousel.Item key={slide.id}>
          <div
            data-aos="fade-up"
            className={styles.carouselItem}
            style={{
              backgroundImage: `url(${slide.image})`,
              opacity: imageLoaded[slide.id] ? 1 : 0.7,
              transition: "opacity 0.3s ease",
            }}
          >
            <img
              src={slide.image}
              alt=""
              style={{ display: "none" }}
              onLoad={() => handleImageLoad(slide.id)}
            />
            <div className={styles.overlay}>
              <h1 className={styles.title}>{slide.title}</h1>
              <p className={styles.subtitle}>{slide.subtitle}</p>
              <Button className={styles.btn} href={slide.buttonLink}>
                {slide.buttonText}
              </Button>
            </div>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default HeroSection;
